export default __webpack_public_path__ + "static/media/no-time.3743ef87.png";